import { z } from '@/utils/zod'

export const StorageResourceSchema = z.object({
    resource: z.string().min(1),
    contentType: z.string().optional(),
    fileSizeBytes: z.number().int().positive().optional(),
})

export type StorageResource = z.infer<typeof StorageResourceSchema>

export const InputStorageResourceSchema = z.string().refine(
    (val) => {
        return !!val
    },
    {
        params: {
            i18n: { key: 'custom.resourceRequired' },
        },
    }
)

export type InputStorageResource = z.infer<typeof InputStorageResourceSchema>

export const StorageResourcesSchema = z.array(
    StorageResourceSchema.extend({
        id: z.string().min(6).max(6),
    })
)

export type StorageResources = z.infer<typeof StorageResourcesSchema>

export const InputStorageResourcesSchema = z.array(
    z.object({
        id: z.string().min(6).max(6).optional(),
        resource: InputStorageResourceSchema,
    })
)

export type InputStorageResources = z.infer<typeof InputStorageResourcesSchema>

export type ExtractedStorageResource = { resource: string; url: string }

export const extractStorageResource = (resource: StorageResource | null): ExtractedStorageResource | null => {
    return resource?.resource ? { resource: resource.resource, url: resource.resource } : null
}

export const createInputStorageResource = (resource: ExtractedStorageResource | null): InputStorageResource => {
    return resource?.resource || ''
}

type ExtractedStorageResources = Array<{ id?: string } & ExtractedStorageResource>

export const extractStorageResources = (resources: StorageResources): ExtractedStorageResources =>
    resources.map(({ id, resource }) => ({ id, resource, url: resource }))

export const createInputStorageResources = (resources: ExtractedStorageResources): InputStorageResources =>
    resources.map(({ id, resource }) => ({ id, resource }))
